export default "/_next/static/images/2023-1x-e4006a65128b77facefc4168c8c046d0.png";